import { Link } from 'react-router-dom';
import { academyOverviewLinks } from '@/mocks/aboutData';
import { useTranslation } from 'react-i18next';

export default function AcademyOverview() {
  const { t } = useTranslation();
  const overviewLinkKeys = [
    { titleKey: 'about.overview.link1.title', descKey: 'about.overview.link1.desc', icon: academyOverviewLinks[0].icon, href: academyOverviewLinks[0].href },
    { titleKey: 'about.overview.link2.title', descKey: 'about.overview.link2.desc', icon: academyOverviewLinks[1].icon, href: academyOverviewLinks[1].href },
    { titleKey: 'about.overview.link3.title', descKey: 'about.overview.link3.desc', icon: academyOverviewLinks[2].icon, href: academyOverviewLinks[2].href },
    { titleKey: 'about.overview.link4.title', descKey: 'about.overview.link4.desc', icon: academyOverviewLinks[3].icon, href: academyOverviewLinks[3].href },
    { titleKey: 'about.overview.link5.title', descKey: 'about.overview.link5.desc', icon: academyOverviewLinks[4].icon, href: academyOverviewLinks[4].href },
    { titleKey: 'about.overview.link6.title', descKey: 'about.overview.link6.desc', icon: academyOverviewLinks[5].icon, href: academyOverviewLinks[5].href },
  ];
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            EXPLORE
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('about.overview.title')}
          </h2>
          {String(t('about.overview.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-6"></div>
          {String(t('about.overview.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {overviewLinkKeys.map((link, idx) => (
            <Link
              key={idx}
              to={link.href}
              className="card-glow group block bg-background-100/60 border border-background-200/60 p-5 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${link.icon} text-accent-500 text-base`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-1.5 group-hover:text-accent-600 transition-colors">
                    {t(link.titleKey)}
                  </h3>
                  {String(t(link.descKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">{__s}</p>))}
                  <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                    <span className="text-[13px] tracking-[0.06em]">{t('about.overview.viewLink')}</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}